import { useState, useRef } from 'react';
import { Search, Crosshair, Zap } from 'lucide-react';
import './FindImageShowcase.css';

const FindImageShowcase = ({ onPlayClick }) => {
  const heroRef = useRef(null);
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
  const [showCrosshair, setShowCrosshair] = useState(false);

  const handleMouseMove = (e) => {
    const rect = heroRef.current.getBoundingClientRect();
    setCursorPos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };

  return (
    <div className="fi-showcase">
      {/* Left: Hero image with scanner */}
      <div
        className="fi-showcase__hero"
        ref={heroRef}
        onClick={onPlayClick}
        onMouseMove={handleMouseMove}
        onMouseEnter={() => setShowCrosshair(true)}
        onMouseLeave={() => setShowCrosshair(false)}
      >
        <div className="fi-showcase__hero-img">
          <img src="/images/find-image-card-bg.png" alt="" />
        </div>
        <div className="fi-showcase__scanner" />
        <div className="fi-showcase__hero-overlay" />
        <div
          className={`fi-showcase__crosshair ${showCrosshair ? 'fi-showcase__crosshair--visible' : ''}`}
          style={{
            left: cursorPos.x,
            top: cursorPos.y
          }}
        >
          <Crosshair />
        </div>
        <div className="fi-showcase__hero-content">
          <span className="fi-showcase__label">
            <Search /> Find The Image
          </span>
          <h2 className="fi-showcase__title">Be the First</h2>
          <p className="fi-showcase__description">
            Race to spot the hidden object in an AI-generated scene
          </p>
        </div>
      </div>

      {/* Right: Action cards */}
      <div className="fi-showcase__actions">
        {/* Play Now card */}
        <div className="fi-showcase__card">
          <div className="fi-showcase__card-label">
            <Zap /> Ready to Play
          </div>
          <h3 className="fi-showcase__card-title">Jump into a round</h3>
          <p className="fi-showcase__card-desc">
            Host a game or join with a code. AI generates the scene, you find the target first.
          </p>
          <button className="fi-showcase__play-btn" onClick={onPlayClick}>
            Play Now
          </button>
        </div>

        {/* How It Works card */}
        <div className="fi-showcase__card">
          <div className="fi-showcase__card-label">
            <Crosshair /> How It Works
          </div>
          <h3 className="fi-showcase__card-title">Spot it before anyone else</h3>
          <p className="fi-showcase__card-desc">
            A hidden object is placed in an AI-generated scene. First player to click on it wins the round.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FindImageShowcase;
